import React from 'react';
import { useAppDispatch } from '../../../../../redux/hooks';
import Syndicate from '../../../../Auth/utils/Syndicate';
import { ModalSliceType, openModal } from '../../../../../redux/slices/modal';
import { PrimaryButton } from '../../../../../components/Button';
import usePermission from '../../../../../utils/hooks/permissionHooks';
import { PermissionKey } from '../../../../../utils/apollo/graphqlSchema';
import PermissionElementWrapper from '../../../../PermissionControls/PermissionElementWrapper';
import KubitTooltip from '../../../../../components/KubitTooltip';
import useCustomerPlan, {
  getMaxSeatsTooltip,
} from '../../../../../utils/hooks/useCustomerPlan';

const InviteNewUserAction = () => {
  const dispatch = useAppDispatch();
  const { isMigration } = Syndicate.getData();

  const { maxSeats, reachMaxSeats } = useCustomerPlan();

  const { checkIsPermitted } = usePermission();
  const isPermittedToInviteUsers = checkIsPermitted({
    requiredPermissionKeys: [PermissionKey.UserInvite],
  });

  const handleInviteNewUser = () => {
    dispatch(openModal({ type: ModalSliceType.UserInviteNewUsers }));
  };

  const maxSeatsTooltipContent = getMaxSeatsTooltip(maxSeats);
  return (
    <PermissionElementWrapper isPermitted={isPermittedToInviteUsers}>
      <KubitTooltip
        disabled={
          !reachMaxSeats || !isPermittedToInviteUsers || !maxSeatsTooltipContent
        }
        content={maxSeatsTooltipContent}
      >
        <PrimaryButton
          type="button"
          onClick={handleInviteNewUser}
          disabled={isMigration || !isPermittedToInviteUsers || reachMaxSeats}
          trackContext="invite users"
          trackAction="invite new user"
        >
          Invite New User
        </PrimaryButton>
      </KubitTooltip>
    </PermissionElementWrapper>
  );
};

export default InviteNewUserAction;
